import React, { useEffect, useState } from "react";
import Icon from "@material-ui/core/Icon";
import { Tooltip } from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";
import ChartistGraph from "react-chartist";
import EditIcon from '@material-ui/icons/Edit';
import ReplayIcon from '@material-ui/icons/Replay';
import { Tab, Tabs, AppBar } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import BiztranControls from "../../components/biztran_controls/BiztranControls";
import Store from "@material-ui/icons/Store";
import Warning from "@material-ui/icons/Warning";
import DateRange from "@material-ui/icons/DateRange";
import LocalOffer from "@material-ui/icons/LocalOffer";
import Update from "@material-ui/icons/Update";
import ArrowUpward from "@material-ui/icons/ArrowUpward";
import AccessTime from "@material-ui/icons/AccessTime";
import Accessibility from "@material-ui/icons/Accessibility";
import BugReport from "@material-ui/icons/BugReport";
import Code from "@material-ui/icons/Code";
import Cloud from "@material-ui/icons/Cloud";
import BusinessCenterIcon from "@material-ui/icons/BusinessCenter";
import AssignmentIcon from "@material-ui/icons/Assignment";
import LocalAtmIcon from "@material-ui/icons/LocalAtm";
import ListIcon from "@material-ui/icons/List";
import LocalAtm from "@material-ui/icons/LocalAtm";
import Activities from "../../components/crm/Activities"
import Tasks from "../biztran_controls/Tasks/Tasks.js";
import Table from "../biztran_controls/Table/Table.js";
import CustomTabs from "../biztran_controls/CustomTabs/CustomTabs.js";
import GridItem from "../biztran_controls/Grid/GridItem";
import GridContainer from "../biztran_controls/Grid/GridContainer";
import Card from "../biztran_controls/Card/Card";
import CardHeader from "../biztran_controls/Card/CardHeader.js";
import CardIcon from "../biztran_controls/Card/CardIcon.js";
import CardBody from "../biztran_controls/Card/CardBody.js";
import CardFooter from "../biztran_controls/Card/CardFooter.js";
import Danger from "../biztran_controls/Typography/Danger";
import 'moment/locale/it.js';
import 'rc-datepicker/lib/style.css';
import { DatePickerInput } from 'rc-datepicker';
import UseFetchData from "../../hooks/UseFetchData";
import PersonIcon from '@material-ui/icons/Person';
import blue from "@material-ui/core/colors/blue";
import Moment from "moment";
import { Grid, IconButton, Typography, Popover, List, ListItem, ListItemAvatar, ListItemText, Avatar } from '@material-ui/core';
import { dailySalesChart, emailsSubscriptionChart, completedTasksChart } from "../../variables/charts";
import { activities, notes, others } from "../../variables/general.js";
import styles from "../../assets/jss/material-dashboard-react/views/dashboardStyle.js";
import { NfcTwoTone, Schedule } from "@material-ui/icons";
import { GridToolbarContainer } from "@mui/x-data-grid";
import { ensureUnit } from "chartist";


// let fromDate = new Date().getFullYear() + "/04/01"
// let Dfromdate = new Date().getFullYear() + '/01/01';
const currentDate = new Date();
const currentMonth = currentDate.getMonth() + 1;
const currentYear = currentDate.getFullYear();

let fromDate, Dfromdate, DToDate;

if (currentMonth >= 4) {
    fromDate = new Date(currentYear + "/04/01");
    Dfromdate = new Date(currentYear + "/04/01");
    DToDate = new Date((currentYear + 1) + "/03/31");
} else {
    fromDate = new Date((currentYear - 1) + "/04/01");
    Dfromdate = new Date((currentYear - 1) + "/04/01");
    DToDate = new Date(currentYear + "/03/31");
}

const useStyles = makeStyles(styles);

const Dashboard = (props) => {
    const classes = useStyles();

    const [FromDate, setFromDate] = useState(fromDate);
    const [UserName, setUserName] = useState(sessionStorage.UserName);
    const [UserID, setUserID] = useState((sessionStorage.UserType === "Admin" || sessionStorage.UserType === "Sales Manager") ? "" : sessionStorage.UID);
    const [defaultfromDate, setdefaultfromDate] = useState(fromDate);
    const [ToDate, setToDate] = useState(DToDate);
    const [defaultToDate, setdefaultToDate] = useState(DToDate);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [anchorE2, setAnchorE2] = React.useState(null);
    const [UserData, setUserData] = useState([]);
    const [ActivityData, setActivityData] = useState([]);
    const [NotesData, setNotesData] = useState([]);
    const [Q1Target, setQ1Target] = useState(0);
    const [Q1Actual, setQ1Actual] = useState(0);
    const [Q2Target, setQ2Target] = useState(0);
    const [Q2Actual, setQ2Actual] = useState(0);
    const [Q3Target, setQ3Target] = useState(0);
    const [Q3Actual, setQ3Actual] = useState(0);
    const [Q4Target, setQ4Target] = useState(0);
    const [Q4Actual, setQ4Actual] = useState(0);
    const [Count, setCount] = useState();
    const [CountryID, setCountryID] = useState("");
    const [Countrycmb, setCountrycmb] = useState([]);
    const [responseCountry, fetchCountryData] = UseFetchData();
    const [OPCount, setOPCount] = useState(0);
    const [QTCount, setQTCount] = useState(0);
    const [SOCount, setSOCount] = useState(0);
    const [OPTotal, setOPTotal] = useState(0);
    const [QTTotal, setQTTotal] = useState(0);
    const [SOTotal, setSOTotal] = useState(0);
    const [schedule, setschedule] = useState("Daily");
    const [AMode, setAMode] = useState('DashBoard');
    const [isChecked, setIsChecked] = useState(false);
    const [ScheduleStage, setScheduleStage] = useState("");
    const [MaxTAC, setMaxTAC] = useState();
    const [MaxTAC1, setMaxTAC1] = useState();
    const [ActivityID, setActivityID] = useState("");
    const [RefDocumentID, setRefferenceID] = useState("");
    const [MaxQT, setMaxQT] = useState();
    const [MaxTA, setMaxTA] = useState();
    const [MaxAct, setMaxAct] = useState();
    const [ActivitytasksIndexes, setActivitytasksIndexes] = useState([]);
    const [NotestasksIndexes, setNotestasksIndexes] = useState([]);
    const [SalesAnalysisData, setSalesAnalysisData] = useState([]);
    const [QuotationAnalysisData, setQuotationAnalysisData] = useState([]);
    const [CustomerData, setCustomerData] = useState([]);
    const [ComapnyData, setComapnyData] = useState([]);
    const [TargetVsActualChart, setTargetVsActualChart] = useState();
    const [TargetVsActualChart1, setTargetVsActualChart1] = useState();
    const [QuotationChart, setQuotationChart] = useState();
    const [ActivitiesChart, setActivitiesChart] = useState([]);
    const [responseUsers, fetchUsersData] = UseFetchData();
    const [responseDtls, fetchDtlsData] = UseFetchData();
    const [responseCompany, fetchCompanyData] = UseFetchData();
    const [FilterStage, setFilterStage] = useState("");
    const [ResponseDisplay, fetchDisplayData] = UseFetchData();

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
        setActivityID(ActivityID);
        console.log(id);
    };



    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleEventClick = (event) => {
        setAnchorE2(event.currentTarget);
        setActivityID(ActivityID);
        console.log(event.currentTarget);

    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    const handleListItemClick = (value) => {
        const targetID = value.UserName === "Admin" ? "" : value.UserID;
        setUserID(targetID);
        setUserName(value.UserName);
        handleClose();
        // Use timeout to ensure state has updated or pass value directly
        Populate(targetID);
    };

    const onFromClear = () => {
        setFromDate();
        setdefaultfromDate();
    }






    const onCheckChange = (e) => {
        // debugger;
        setIsChecked(e.target.checked);
        console.log(isChecked);
    };


    const onToClear = () => {
        setToDate();
        setdefaultToDate();
    }

    const CountryData = () => {
        var bodyFormData = new FormData();
        fetchCountryData("Account/ComboDataAccount", bodyFormData);
    }



    const AllUsersDtls = () => {
        var bodyFormData = new FormData();
        bodyFormData.append("SearchString", '');
        bodyFormData.append("UserType", sessionStorage.UserType);
        bodyFormData.append("UserGroupID", sessionStorage.UserGroupID);
        fetchUsersData("User/DashboardList", bodyFormData);
    }

    const Populate = (targetUserID) => {
        const uid = (targetUserID !== undefined && targetUserID !== null) ? targetUserID : UserID;
        const bodyFormData = new FormData();
        bodyFormData.append("UserID", uid);

        if (!isChecked) {
            bodyFormData.append("UserType", sessionStorage.UserType);
            bodyFormData.append("UserGroupID", sessionStorage.UserGroupID);
            bodyFormData.append("FinacialDate", Moment(fromDate).format('YYYY-MM-DD'));
            bodyFormData.append("CountryID", CountryID);
            bodyFormData.append("AMode", AMode);
        }

        const fDate = FromDate ? Moment(FromDate).format('YYYY-MM-DD') : Moment(Dfromdate).format('YYYY-MM-DD');
        bodyFormData.append("FromDate", fDate);

        const tDate = ToDate ? Moment(ToDate).format('YYYY-MM-DD') : Moment(DToDate).format('YYYY-MM-DD');
        bodyFormData.append("ToDate", tDate);
        bodyFormData.append("LoggedUserID", sessionStorage.UID);

        fetchDtlsData("Dashboard/View", bodyFormData);
    }

    useEffect(() => {
        Populate(UserID);
    }, [FromDate, ToDate, UserID, CountryID, AMode, isChecked]);

    useEffect(() => {
        AllUsersDtls();
        CountryData();
    }, []);


    var data3 = {
        labels: ['W1', 'W2', 'W3', 'W4', 'W5', 'W6', 'W7', 'W8', 'W9', 'W10'],
        series: [
            [1, 2, 4, 8, 6, -2, -1, -4, -6, -2]
        ]
    };

    var options3 = {
        high: 10,
        low: -10,
        axisX: {
            labelInterpolationFnc: function (value, index) {
                return index % 2 === 0 ? value : null;
            }
        }
    };

    useEffect(() => {
        if (responseCountry !== undefined) {
            if (responseCountry["cmbCountry"] !== undefined) {
                const sortedCountry = [...responseCountry["cmbCountry"]].sort((a, b) =>
                    a.title.localeCompare(b.title)
                );
                setCountrycmb(sortedCountry);
            }
        }
    }, [responseCountry]);

    useEffect(() => {
        if (responseUsers !== undefined && responseUsers.length > 0) {
            setUserData(responseUsers);
        }
    }, [responseUsers]);




    useEffect(() => {
        if (responseDtls.Activity && responseDtls.Activity.length > 0) {
            var index = [];
            for (var i = 0; i < responseDtls.Activity.length; i++) {
                index.push(i);
            }
            setActivityData(responseDtls.Activity);
            setActivitytasksIndexes(index);
        }
        else {
            setActivityData([]);
            setActivitytasksIndexes([]);
        }


        if (responseDtls.Notes && responseDtls.Notes.length > 0) {
            var index = [];
            for (var i = 0; i < responseDtls.Notes.length; i++) {
                index.push(i);
            }
            setNotesData(responseDtls.Notes);
            setNotestasksIndexes(index);
        }
        else {
            setNotesData([]);
            setNotestasksIndexes([]);
        }


        if (responseDtls.TargetVsActualQty !== undefined && responseDtls.TargetVsActualQty.length > 0) {
            for (var i = 0; i < responseDtls.TargetVsActualQty.length; i++) {
                if (responseDtls.TargetVsActualQty[i].Qty === 1) {
                    setQ1Actual((responseDtls.TargetVsActualQty[i].Actual).toFixed(2));
                    setQ1Target((responseDtls.TargetVsActualQty[i].Target).toFixed(2));
                }
                if (responseDtls.TargetVsActualQty[i].Qty === 2) {
                    setQ2Actual((responseDtls.TargetVsActualQty[i].Actual).toFixed(2));
                    setQ2Target((responseDtls.TargetVsActualQty[i].Target).toFixed(2));
                }
                if (responseDtls.TargetVsActualQty[i].Qty === 3) {
                    setQ3Actual((responseDtls.TargetVsActualQty[i].Actual).toFixed(2));
                    setQ3Target((responseDtls.TargetVsActualQty[i].Target).toFixed(2));
                }
                if (responseDtls.TargetVsActualQty[i].Qty === 4) {
                    setQ4Actual((responseDtls.TargetVsActualQty[i].Actual).toFixed(2));
                    setQ4Target((responseDtls.TargetVsActualQty[i].Target).toFixed(2));
                }
            }
        }


        if (responseDtls.AllDtlsData !== undefined && responseDtls.AllDtlsData.length > 0) {
            for (var i = 0; i < responseDtls.AllDtlsData.length; i++) {
                if (responseDtls.AllDtlsData[i].type === 'OP') {
                    setOPCount(responseDtls.AllDtlsData[i].Count);
                    setOPTotal(responseDtls.AllDtlsData[i].Total === null ? 0 : responseDtls.AllDtlsData[i].Total);
                }
                if (responseDtls.AllDtlsData[i].type === 'QT') {
                    setQTCount(responseDtls.AllDtlsData[i].Count);
                    setQTTotal(responseDtls.AllDtlsData[i].Total === null ? 0 : responseDtls.AllDtlsData[i].Total);
                }
                if (responseDtls.AllDtlsData[i].type === 'SO') {
                    setSOCount(responseDtls.AllDtlsData[i].Count);
                    setSOTotal(responseDtls.AllDtlsData[i].Total === null ? 0 : responseDtls.AllDtlsData[i].Total);
                }
            }
        }


        if (responseDtls.SalesAnalysisYearly !== undefined && responseDtls.SalesAnalysisYearly.length > 0) {
            var data = [];
            for (var i = 0; i < responseDtls.SalesAnalysisYearly.length; i++) {
                var sales = []
                sales.push(responseDtls.SalesAnalysisYearly[i].Country, responseDtls.SalesAnalysisYearly[i].Year, responseDtls.SalesAnalysisYearly[i].SalesINR);
                data.push(sales)
            }
            setSalesAnalysisData(data)
        }
        else {
            setSalesAnalysisData([])
        }

        if (responseDtls.QuotationAnalysisYearly !== undefined && responseDtls.QuotationAnalysisYearly.length > 0) {
            //debugger;
            var data = [];
            for (var i = 0; i < responseDtls.QuotationAnalysisYearly.length; i++) {
                var sales = []
                sales.push(responseDtls.QuotationAnalysisYearly[i].Country, responseDtls.QuotationAnalysisYearly[i].Quotation, responseDtls.QuotationAnalysisYearly[i].Open, responseDtls.QuotationAnalysisYearly[i].Close);
                data.push(sales)
            }
            setQuotationAnalysisData(data)
        } else {
            setQuotationAnalysisData([])
        }


        if (responseDtls.CompanyDataYearly !== undefined && responseDtls.CompanyDataYearly.length > 0) {
            var data = [];
            for (var i = 0; i < responseDtls.CompanyDataYearly.length; i++) {

                var sales = []
                sales.push(responseDtls.CompanyDataYearly[i].CompanyName, responseDtls.CompanyDataYearly[i].Year, responseDtls.CompanyDataYearly[i].SalesINR, responseDtls.CompanyDataYearly[i].QutINR)
                data.push(sales)

            }
            setComapnyData(data)
        }
        else {
            setComapnyData([])
        }



        if (responseDtls.TargetVsActualChart !== undefined && responseDtls.TargetVsActualChart.length > 0) {
            var Month = [4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3];
            var data = [];
            var data1 = [];
            var flag = false;
            for (var i = 0; i < Month.length; i++) {
                flag = false;
                for (var j = 0; j < responseDtls.TargetVsActualChart.length; j++) {
                    if (responseDtls.TargetVsActualChart[j].Mth === Month[i]) {
                        flag = true;
                        data.push(responseDtls.TargetVsActualChart[j].Percentage * 1);
                        data1.push(responseDtls.TargetVsActualChart[j].TargetInLakhs * 1);
                    }
                }
                if (flag === false) {
                    data.push(0);
                    data1.push(0);
                }
            }
            const MaxTAData = Math.max(...data1)
            console.log(MaxTAData);
            setMaxTA(MaxTAData + 1)

            var DtlsData = {
                labels: ["Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec", "Jan", "Feb", "Mar",],
                series: [
                    { name: 'data1', data: data1 }, // First series
                    { name: 'data', data: data }    // Second series
                ]
            }
            console.log("data::", data);
            setTargetVsActualChart(DtlsData);
        }



        if (responseDtls.QuotationChart !== undefined && responseDtls.QuotationChart.length > 0) {
            var Month = [4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3];
            var data = [];
            var flag = false;
            for (var i = 0; i < Month.length; i++) {
                flag = false;
                for (var j = 0; j < responseDtls.QuotationChart.length; j++) {
                    if (responseDtls.QuotationChart[j].Mth === Month[i]) {
                        flag = true;
                        data.push(responseDtls.QuotationChart[j].Total / 10000000);
                    }
                }
                if (flag === false) {
                    data.push(0);
                }
            }
            const MaxQTData = Math.max(...data)
            console.log(MaxQTData);
            setMaxQT(MaxQTData + 1)
            var DtlsData = {
                labels: ["Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec", "Jan", "Feb", "Mar",],
                series: [{ data }]
            }
            console.log(DtlsData);
            setQuotationChart(DtlsData);
        }
        else {
            setMaxQT(5)
            var DtlsData = {
                labels: ["Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec", "Jan", "Feb", "Mar",],
                series: [[]]
            }
            console.log(DtlsData);
            setQuotationChart(DtlsData);
        }
    }, [responseDtls])

    const data123 = {
        labels: ["Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec", "Jan", "Feb", "Mar",],
        series: [
            [10, 10, 10, 10, 10, 10, 10, 10, 10, 10],
            [10, 10, 10, 10, 10, 5, 1, 23, 5, 5]],
    };
    console.log("Data123", data123);

    const options123 = {
        high: 15,
        low: 0,
        showArea: true,
        axisX: {
            showLabel: true,
        },
        axisY: {
            showLabel: true,
        },
    };

    return (

        <div>
            <Grid spacing={1} container direction="row">
                <Grid item xs={3}>
                    <p className={classes.cardCategory} style={{ fontSize: 29, marginTop: 3 }}> Dashboard of {UserName} </p>
                </Grid>
                <Grid item xs={1}>
                    <IconButton style={{ marginTop: 10 }} aria-describedby={id} variant="contained" onClick={handleClick}>
                        <EditIcon />
                    </IconButton>
                </Grid>
                <Grid item xs={3}></Grid>
                <Grid item xs>
                    <div style={{ width: '160px' }}>
                        <label style={{ color: "grey", fontSize: 12 }}>From Date</label>
                        <DatePickerInput
                            value={FromDate}
                            onChange={(jsDate, dateString) => setFromDate(jsDate)}
                            locale="en"
                            displayFormat="DD/MMM/YYYY"
                            className='my-react-component'
                            onClear={() => { onFromClear(); }}
                            showOnInputClick
                            maxDate={new Date()}
                            returnFormat="YYYY/MM/DD"
                        />
                    </div>
                </Grid>
                <Grid item xs>
                    <div style={{ width: '160px' }} >
                        <label style={{ color: "grey", fontSize: 12 }}>To Date</label>
                        <DatePickerInput
                            value={ToDate}
                            onChange={(jsDate, dateString) => setToDate(jsDate)}
                            locale="en"
                            displayFormat="DD/MMM/YYYY"
                            className='my-react-component'
                            onClear={() => { onToClear(); }}
                            showOnInputClick
                            returnFormat="YYYY/MM/DD"
                        />
                    </div>
                </Grid>
                <Grid item xs>
                    <IconButton style={{ marginTop: 13 }}>
                        <ReplayIcon onClick={() => { Populate(UserID); }} />
                    </IconButton>
                </Grid>
            </Grid>
            <GridContainer>
                <GridItem xs={12} sm={12} md={6}>
                    <Card chart>
                        <CardHeader color="warning">
                            <h4 className={classes.cardTitle}>Monthly Sales Target Vs Actual</h4>
                            <ChartistGraph
                                className="ct-labels"
                                data={TargetVsActualChart}
                                type="Bar"
                                options={{
                                    axisX: {
                                        showGrid: false,
                                    },
                                    low: 0,
                                    high: MaxTA,//MaxTAC,
                                    chartPadding: {
                                        top: 0,
                                        right: 20,
                                        bottom: 0,
                                        left: 0,
                                    },
                                }}
                                responsiveOptions={emailsSubscriptionChart.responsiveOptions}
                                listener={emailsSubscriptionChart.animation}
                            />
                        </CardHeader>
                        <Grid spacing={1} container direction="row" xs={12} sm={12} md={12}>
                            <Grid xs={6} sm={6} md={6}>
                                <div style={{ height: 70 }}>
                                    <Card>
                                        <CardHeader color="success" stats icon>
                                            <CardIcon color="success">
                                                <LocalAtm />
                                            </CardIcon>
                                            <p className={classes.cardCategory}>Quotation</p>
                                            <h3 className={classes.cardTitle}>{QTCount}</h3>
                                            <p className={classes.cardCategory} style={{ marginTop: -9 }}>₹ {QTTotal}</p>
                                        </CardHeader>
                                    </Card>
                                </div>
                            </Grid>
                            <Grid xs={3} sm={3} md={6} >
                                <div style={{ height: 70 }} >
                                    <Card>
                                        <CardHeader color="info" stats icon>
                                            <CardIcon color="info">
                                                <AssignmentIcon />
                                            </CardIcon>
                                            <p className={classes.cardCategory}>SalesOrder</p>
                                            <h3 className={classes.cardTitle}>{SOCount}</h3>
                                            <p className={classes.cardCategory} style={{ marginTop: -9 }}>₹ {SOTotal}</p>
                                        </CardHeader>
                                    </Card>
                                </div>
                            </Grid>
                        </Grid>
                    </Card>
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                    <Card chart>
                        <CardHeader color="success">
                            <h4 className={classes.cardTitle}>Monthly Quotations</h4>
                            <ChartistGraph
                                className="ct-chart"
                                data={QuotationChart}
                                type="Bar"
                                options={{
                                    low: 0,
                                    high: MaxQT,
                                    chartPadding: {
                                        top: 0,
                                        right: 5,
                                        bottom: 0,
                                        left: 0,
                                    },
                                }}
                                listener={dailySalesChart.animation}
                            />
                        </CardHeader>
                        <CardBody style={{ height: 80 }}>
                            <p className={classes.cardCategory}>
                                <span className={classes.successText}>
                                    {/* <ArrowUpward className={classes.upArrowCardCategory} /> 55% */}
                                </span>{" "}
                                {/* increase in today quotations. */}
                            </p>
                        </CardBody>
                    </Card>
                </GridItem>
            </GridContainer>
            <GridContainer>
                <GridItem xs={12} sm={12} md={6}>
                    <Card style={{ height: 385 }} >
                        <CardHeader color="warning">
                            <h4 className={classes.cardTitleWhite}>
                                Sales Analysis
                            </h4>
                            <p className={classes.cardCategoryWhite}>
                                Sales Analysis - Current Year
                            </p>
                            <Grid item xs={8} sm={4} md={2} lg={2} xl={2} style={{ marginTop: -50, marginLeft: 400 }}>
                                <BiztranControls.Select
                                    label="Country"
                                    id="Country"
                                    width="180px"
                                    options={Countrycmb}
                                    onChange={(e) => setCountryID(e.target.value)}
                                />
                            </Grid>
                            <Grid style={{ marginTop: -5, marginLeft: 530 }}>
                                <Tooltip title="SEARCH">
                                    <IconButton style={{ marginLeft: 70, marginTop: -70 }} onClick={() => { Populate(UserID); }}>
                                        <SearchIcon />
                                    </IconButton>
                                </Tooltip>
                            </Grid>
                        </CardHeader>
                        <CardBody >
                            <Table
                                tableHeaderColor="warning"
                                tableHead={["Country", "Year", "Sales INR"]}
                                tableData={SalesAnalysisData}
                            />
                        </CardBody>
                    </Card>
                </GridItem>
                <GridItem xs={12} sm={6} md={6}>
                    <Card >
                        <CardHeader color="success" >
                            <h4 className={classes.cardTitleWhite}>
                                Quotation Analysis
                            </h4>
                            <p className={classes.cardCategoryWhite}>
                                Quotation Analysis - Current Year
                            </p>
                        </CardHeader>
                        <CardBody >
                            <Table
                                tableHeaderColor="success"
                                tableHead={["Country", "Quotation", "Open", "Close"]}
                                tableData={QuotationAnalysisData === null && QuotationAnalysisData === "" ? 0 : QuotationAnalysisData}
                            />
                        </CardBody>
                    </Card>
                </GridItem>
            </GridContainer>
            <GridContainer>

                <GridItem xs={12} sm={6} md={6} >
                    {
                        <CustomTabs
                            title="Details : "
                            headerColor="primary"
                            Populate={() => Populate('')}
                            tabs={[
                                {
                                    tabName: "Activities",
                                    tabIcon: Code,
                                    tabContent: (
                                        <Tasks
                                            Populate={() => Populate('')}
                                            value={0}
                                            checkedIndexes={[0, 5]}
                                            tasksIndexes={ActivitytasksIndexes}
                                            tasks={ActivityData}
                                        />
                                    ),
                                },
                                {
                                    tabName: "Notes",
                                    tabIcon: AssignmentIcon,
                                    tabContent: (
                                        <Tasks
                                            Populate={() => Populate('')}
                                            value={1}
                                            checkedIndexes={[0]}
                                            tasksIndexes={NotestasksIndexes}
                                            tasks={NotesData}
                                        />
                                    ),
                                },
                            ]}
                        />
                    }
                </GridItem>
                <GridItem xs={12} sm={12} md={6}  >
                    <Card style={{ height: 370 }} >
                        <CardHeader color="danger">
                            <h4 className={classes.cardTitleWhite}>
                                Company Data
                            </h4>
                            <p className={classes.cardCategoryWhite}>
                                Company Data - Current Year
                            </p>
                        </CardHeader>
                        <CardBody>
                            <Table
                                tableHeaderColor="warning"
                                tableHead={["Company", "Year", "Sales INR", "Qut INR"]}
                                tableData={ComapnyData}
                            />
                        </CardBody>
                    </Card>
                </GridItem>
            </GridContainer>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
            >
                <List sx={{ pt: 0 }}>
                    {UserData.map((Users) => (
                        <ListItem button onClick={() => handleListItemClick(Users)} key={Users.id}>
                            <ListItemAvatar>
                                <Avatar sx={{ bgcolor: blue[100], color: blue[600] }}>
                                    <PersonIcon />
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText primary={Users.UserName} />
                        </ListItem>
                    ))}
                </List>
            </Popover>
        </div>
    );
};

export default Dashboard;
